import styled from 'styled-components';
const Section = styled.div.withConfig({
  displayName: "Section",
  componentId: "sc-9xheb5-0"
})(["padding:16px 20px;border-bottom:1px solid rgb(236,238,241);"]);
export default Section;